<!-- https://primefaces.org/primeng/showcase/#/setup -->

<!-- 				-->
<!-- Confirm Dialog -->
<!-- 				-->
<p-confirmDialog [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!-- 		 	 -->
<!-- LOCK TO TOP -->
<!-- 			 -->
<div class="lock-to-top" style="background-color: #ffffff">
	<!-- 		         -->
	<!-- School Selector -->
	<!-- 		         -->
	<div class="school-body">
		<div class="selector-body">
			<div class="selector-item">
				<div>
					<label>School</label>
				</div>
		
				<div style="margin-left: 10px">
					<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
					<caass-schoolselector [ShowAll]="false" [Disabled]="isBusy" [TableTypeID]="4"> </caass-schoolselector>
				</div>
		
				<!-- 				   -->
				<!-- Display When Busy -->
				<!-- 				   -->
				<div style="margin-left: 20px" [style.display]="isBusy == true ? 'block' : 'none'">
					<img class="busy-img" src="assets/images/loading.gif" />
				</div>
			</div>
		</div>
	</div>

	<!-- 		 	   -->
	<!-- Date Selector -->
	<!-- 	  		   -->
	<div class="date-body">
		<div class="selector-body">
			<!-- 				 	-->
			<!-- DateRange Selector -->
			<!-- 				 	-->
			<div class="selector-item">
				<div>
					<label>Date Range</label>
				</div>

				<div style="margin-left: 10px">
					<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
					<select
						class="form-control"
						name="DateRangeSelector"
						style="font-size: smaller"
						[(ngModel)]="SelectedDateRange"
						(ngModelChange)="onDateRangeChange($event)"
					>
						<option *ngFor="let r of lstDateRange" [ngValue]="r">
							{{ r.DateRangeDesc }}
						</option>
					</select>
				</div>
			</div>

			<!-- 			-->
			<!-- Start Date -->
			<!-- 			-->
			<div class="selector-item" [style.display]="this.SelectedDateRange.DateRangeID == 6 ? 'flex' : 'none'">
				<div>
					<label>Start Date</label>
				</div>

				<div style="margin-left: 10px">
					<p-calendar
						[style]="{ width: '100%' }"
						[inputStyle]="{ width: '100%' }"
						[(ngModel)]="rStartDate"
						(ngModelChange)="onStartDateChange($event)"
						[showTime]="false"
						hourFormat="12"
						showIcon="true"
						inputId="startdate"
					></p-calendar>
				</div>
			</div>

			<!-- 			-->
			<!-- End Date -->
			<!-- 			-->
			<div class="selector-item" [style.display]="this.SelectedDateRange.DateRangeID == 6 ? 'flex' : 'none'">
				<div>
					<label>End Date</label>
				</div>

				<div style="margin-left: 10px">
					<p-calendar
						[style]="{ width: '100%' }"
						[inputStyle]="{ width: '100%' }"
						[(ngModel)]="rEndDate"
						(ngModelChange)="onEndDateChange($event)"
						[showTime]="false"
						hourFormat="12"
						showIcon="true"
						inputId="enddate"
					></p-calendar>
				</div>
			</div>
		</div>
	</div>

	<!-- 		 -->
	<!-- Buttons -->
	<!-- 		 -->
	<div class="button-body">
		<button class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onToggleShowSyncData()">Show/Hide Sync Info</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onToggleReturned()" [disabled]="isBusy == true">Toggle Returned</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onAddItem()" [disabled]="isBusy == true">Collect Item</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onEditItem()" [disabled]="isBusy == true">Edit Item</button>
		<img class="info-img" (click)="onToggleInfo()" src="assets/images/info-24.png" />
	</div>

	<div style="padding: 20px; padding-top: 0px; background-color: #ebebeb" [style.display]="isShowInfo == true ? 'block' : 'none'">
		<label>&#9900; Total items collected: {{ lstItemCollectionStudent.length }}</label
		><br />
		<label>&#9900; Use ctl to add a column to the sort selection</label><br />
	</div>

	<!--				-->
	<!-- Error Message  -->
	<!--				-->
	<div class="error-group" [style.display]="ErrorMessage.length == 0 ? 'none' : 'block'">
		<div class="error-div">
			<label class="error-message">{{ ErrorMessage }}</label>
		</div>
	</div>
</div>

<!-- 				  	    -->
<!-- Display Location Items -->
<!-- 					    -->
<div class="table-main-body">
	<!-- Note: resizableColumns breaks the multiline ability -->
	<p-table
		#mydt
		[value]="lstItemCollectionStudent"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedItemCollectionStudent"
		dataKey="ScanPersonalItemID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[10, 25, 50]"
	>
		<ng-template pTemplate="header">
			<!-- 				-->
			<!-- Filter Section -->
			<!-- 				-->
			<tr>
				<th class="fixwidth-06">
					<div class="table-filter-row-group">
						<!-- 				   -->
						<!-- Display When Busy -->
						<!-- 				   -->
						<div [style.display]="isBusy == true ? 'block' : 'none'" style="width: 20px">
							<img class="busy-img" src="assets/images/loading.gif" />
						</div>
						<div [style.display]="isBusy == false ? 'block' : 'none'" style="width: 20px"></div>
					</div>
				</th>

				<th class="fixwidth-09">
					<p-columnFilter field="Returned" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterReturned
								[ngModel]="value"
								[options]="lstReturned"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<th>
					<p-columnFilter type="text" field="StudentID" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<th>
					<p-columnFilter type="text" field="FullName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<th>
					<p-columnFilter type="text" field="LogByFullName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<th class="fixwidth-09">
					<p-columnFilter field="ScanPersonalItemClassDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterScanPersonalItemClassDesc
								[ngModel]="value"
								[options]="lstScanPersonalItemClassDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<th class="fixwidth-09">
					<p-columnFilter field="ScanPersonalItemConditionDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterScanPersonalItemConditionDesc
								[ngModel]="value"
								[options]="lstScanPersonalItemConditionDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<th>
					<p-columnFilter type="text" field="BinNumber" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>				

				<th>
					<p-columnFilter type="text" field="ScanPersonalItemDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>				

				<th>
					<p-columnFilter type="text" field="CollectionDTDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>				

				<th [style.display]="isShowSyncInfo == true ? 'table-cell' : 'none'">
					<p-columnFilter type="text" field="FacilityName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<th [style.display]="isShowSyncInfo == true ? 'table-cell' : 'none'">
					<p-columnFilter type="text" field="ScanStation" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<th [style.display]="isShowSyncInfo == true ? 'table-cell' : 'none'">
					<p-columnFilter type="text" field="SyncDTDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>				

			</tr>

			<!-- 			  -->
			<!-- Sort Section -->
			<!-- 			  -->
			<tr style="height: 4rem">
				<th class="fixwidth-06"></th>
				<th pSortableColumn="Returned" class="fixwidth-09">Returned<p-sortIcon field="Returned"></p-sortIcon></th>
				<th pSortableColumn="StudentID">Student ID<p-sortIcon field="StudentID"></p-sortIcon></th>
				<th pSortableColumn="LastName">Student Name<p-sortIcon field="LastName"></p-sortIcon></th>
				<th pSortableColumn="LogByLastName">Collected By<p-sortIcon field="LogByLastName"></p-sortIcon></th>
				<th class="fixwidth-09" pSortableColumn="ScanPersonalItemClassDesc">Item Type<p-sortIcon field="ScanPersonalItemClassDesc"></p-sortIcon></th>
				<th class="fixwidth-09" pSortableColumn="ScanPersonalItemConditionDesc">Condition<p-sortIcon field="ScanPersonalItemConditionDesc"></p-sortIcon></th>
				<th pSortableColumn="BinNumber">Bin Number<p-sortIcon field="BinNumber"></p-sortIcon></th>
				<th pSortableColumn="ScanPersonalItemDesc">Comments<p-sortIcon field="ScanPersonalItemDesc"></p-sortIcon></th>
				<th pSortableColumn="CollectionDT">Collection Date<p-sortIcon field="CollectionDT"></p-sortIcon></th>
				<th [style.display]="isShowSyncInfo == true ? 'table-cell' : 'none'" pSortableColumn="FacilityName">Facility<p-sortIcon field="FacilityName"></p-sortIcon></th>
				<th [style.display]="isShowSyncInfo == true ? 'table-cell' : 'none'" pSortableColumn="ScanStation">ScanStation<p-sortIcon field="ScanStation"></p-sortIcon></th>
				<th [style.display]="isShowSyncInfo == true ? 'table-cell' : 'none'" pSortableColumn="SyncDT">Sync Date<p-sortIcon field="SyncDT"></p-sortIcon></th>
			</tr>
		</ng-template>

		<ng-template pTemplate="body" let-rCollectedItem>
			<tr [pSelectableRow]="rCollectedItem" (dblclick)="onRowDblClick(rCollectedItem)">
				<td class="fixwidth-06">
					<!-- Fee space filler -->
				</td>

				<td>
					<div class="fixwidth-09">
						<i
							class="pi"
							[ngClass]="{
								'pi-check-circle table-active': rCollectedItem.Returned == 'Yes',
								'pi-ban table-inactive': rCollectedItem.Returned == 'No'
							}"
						></i>
					</div>
				</td>

				<td>
					<div class="table-data-items">
						{{ rCollectedItem.StudentID }}
					</div>
				</td>

				<td>
					<div class="table-data-items">
						{{ rCollectedItem.FullName }}
					</div>
				</td>

				<td>
					<div
						class="table-data-items">
						{{ rCollectedItem.LogByFullName }}
					</div>
				</td>

				<td>
					<div
						class="table-data-items">
						{{ rCollectedItem.ScanPersonalItemClassDesc }}
					</div>
				</td>

				<td>
					<div
						class="table-data-items">
						{{ rCollectedItem.ScanPersonalItemConditionDesc }}
					</div>
				</td>

				<td>
					<div class="table-data-items">
						{{ rCollectedItem.BinNumber }}
					</div>
				</td>

				<td>
					<div class="table-data-items">
						{{ rCollectedItem.ScanPersonalItemDesc }}
					</div>
				</td>

				<td>
					<div class="table-data-items">
						{{ rCollectedItem.CollectionDTDesc }}
					</div>
				</td>

				<td [style.display]="isShowSyncInfo == true ? 'table-cell' : 'none'">
					<div class="table-data-items">
						{{ rCollectedItem.FacilityName }}
					</div>
				</td>

				<td [style.display]="isShowSyncInfo == true ? 'table-cell' : 'none'">
					<div class="table-data-items">
						{{ rCollectedItem.ScanStation }}
					</div>
				</td>

				<td [style.display]="isShowSyncInfo == true ? 'table-cell' : 'none'">
					<div class="table-data-items">
						{{ rCollectedItem.SyncDTDesc }}
					</div>
				</td>

			</tr>
		</ng-template>
	</p-table>
</div>

<!-- 						         -->
<!-- Display When No Collected Items -->
<!-- 					             -->
<div style="padding: 20px" [style.display]="lstItemCollectionStudent.length < 1 && isBusy == false ? 'block' : 'none'">
	<label>No Items Collected...</label>
</div>
